import React from 'react';

import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';


const MyRadioGroup = ({ label, labels, value, onChange, required,  }) => {

    return (

        <FormControl component="fieldset" required={required}>
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup
                value={value.toString()}
                onChange={(event) => { onChange(parseInt(event.target.value)) }}
            >

                {labels.map((l, index) => (<FormControlLabel key={index} value={index.toString()} control={<Radio />} label={l} />))}

            </RadioGroup>
        </FormControl>

    );
};



MyRadioGroup.propTypes = {
    //value: '' OR PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,

    required: PropTypes.bool
};


MyRadioGroup.defaultProps = {
    required: false,
};

export default MyRadioGroup;
